export default __webpack_public_path__ + "static/media/pdfFirstPageImg.906a5713.png";